import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import { getWorkers } from "../../Redux/actions/workers";
import { getQueues , startStopQueues  ,getStartStopQueueStatus ,getDynamicQueues} from "../../Redux/actions/queues";
import EmptyScreen from "../../Assets/Empty-Screen.png";
import loader from "../../Assets/loaderTransaparent.gif";
import stringToDate from "../../Utilities/stringToDate";
import "./index.css";

function Queues(props) {
    const [loading, setLoading] = useState(false);
    const [workerType, setWorkerType] = useState('standard');
    const [worker, setWorker] = useState('0');
    const [workers, setWorkers] = useState([]);
    const [dynamicWorkers, setDynamicWorkers] = useState([]);
    const [queues, setQueues] = useState([]);
    const [queLoading, setQueLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [queueStatus,setQueueStatus]= useState();
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        document.title = "Queues | E-Manager Console | Techforce.ai";
        const fetchData = async () => {
            setLoading(true);
            let data = await getWorkers();
            let dataDynamic=[]
            dataDynamic = data ? data.filter(obj=> obj.worker_type === "dynamic"):[] ;
            data = data ? data.filter(obj=> obj.worker_type === "standard"):[] ;
            setLoading(false);
            if (data && data.length > 0) {
                setWorkers(data);
            }
            if(dataDynamic && dataDynamic.length >0){
                setDynamicWorkers(dataDynamic)
            }
        };
        fetchData();
    }, []);

    const handleReload = async () => {
        setQueLoading(true);
        setRefresh(true);
        await reloadProcess() 
        setQueLoading(false);
        setRefresh(false);
    }
    const handleDynamicWorkersReload=async()=>{
        setQueLoading(true);
        setRefresh(true);
        await reloadProcessDynamic() 
        // await reloadProcess() 
        setQueLoading(false);
        setRefresh(false);
    }
    const reloadProcessDynamic = React.useMemo(() => {
        return async event => {      
            if(worker=="allData"){
                setWorker(worker);
                let data = await getWorkers();
                data = data ? data.filter(obj=> obj.worker_type === "dynamic"):[] ;
                let queues = [];
                if(data.length > 0){
                    queues = await getQueues(data[0].queue_name);
                }
                setQueLoading(false);
                setQueues(queues); 
            }else{
                let data = await getDynamicQueues(worker);  
                setQueues(data)
            }
          
        };
      },[worker]);

    const reloadProcess = React.useMemo(() => {
        return async event => {
          let data = await getQueues(worker);  
           setQueues(data)
        };
      },[worker]);

    const startStopQueue=async ()=>{
        if(queues.length>0){
          var worker_id= queues[queues.length-1].worker_id
        }
        setProcessing(true);
        let status=await startStopQueues(!queueStatus,worker)
        if(status==200){
            setQueueStatus(!queueStatus);
            setProcessing(false);
        }
    }

    const handleChange = async (e) => { 
        if (e.target.type === 'radio') {
            setWorkerType(e.target.name);
            setQueLoading(true);
            if(e.target.name === "dynamic"){
                setQueLoading(false);
                setQueues([]);
            }
            else{
                setQueLoading(false);
                setQueues([]);
            }
            
        }
        else if (e.target.name === 'worker') {
            if(e.target.value !== "0"){
                setWorker(e.target.value);
                setQueLoading(true);
                e.persist();
                let data = await getQueues(e.target.value); 
                let queStatus=await getStartStopQueueStatus(e.target.value);
                if(queStatus){
                   setQueueStatus(queStatus.data.queue_status); 
                }      
                setQueLoading(false);
                setQueues(data);
            }
        }else if(e.target.name === 'dynamicworker'){
            if(e.target.value==="allData"){
                setWorker(e.target.value);
                let data = await getWorkers();
                data = data ? data.filter(obj=> obj.worker_type === "dynamic"):[] ;
                let queues = [];
                if(data.length > 0){
                    queues = await getQueues(data[0].queue_name);
                }
                setQueLoading(false);
                setQueues(queues); 
            }
            else if(e.target.value !== "0"){
                
                setWorker(e.target.value);
                setQueLoading(true);
                e.persist();
                let data=await getDynamicQueues(e.target.value);

                // let data = await getQueues(e.target.value); 
                let queStatus=await getStartStopQueueStatus(e.target.value);
                if(queStatus){
                   setQueueStatus(queStatus.data.queue_status); 
                }      
                setQueLoading(false);
                setQueues(data);
            }
        }
    }
    
    const compare = (a, b) => {
        var nameA=a.created_at
        var nameB=b.created_at
        if (nameA < nameB) 
         return -1;
        if (nameA > nameB)
         return 1;
        return 0; 
    };

    const renderWorkers = () => {
            return (
            <div>
                <div className="form-group form-check form-check-inline">
                    <input className="form-check-input"
                        type="radio" id="inlineCheckbox1"
                        name="standard"
                        onChange={handleChange}
                        checked={workerType === 'standard' ? true : false} />
                    <label className="form-check-label" htmlFor="inlineCheckbox1">Reserved</label>
                </div>
                <div className="form-group form-check form-check-inline">
                    <input className="form-check-input"
                        type="radio" id="inlineCheckbox2"
                        name="dynamic"
                        onChange={handleChange}
                        checked={workerType === 'dynamic' ? true : false} />
                    <label className="form-check-label" htmlFor="inlineCheckbox2">Dynamic</label>
                </div>
                <div>
                    <label htmlFor="worker">E-Worker Machine</label>
                </div>
                {
                    workerType === 'dynamic'? 
                    <div>
                        <div className="form-inline">
                            <div className="form-group mr-3">
                                <select className="form-control" id="worker" name="dynamicworker" value={worker} onChange={handleChange}>
                                    <option value="0">Please select an E-Worker Machine </option>
                                    <option value="allData">All Data</option>
                                    {dynamicWorkers.map((obj, index) => <option key={index} value={obj.worker_name}>{obj.worker_name}</option>)}
                                </select>
                            </div>
                            {
                                worker !== "0" ? 
                                    <div className="form-group">
                                        <button style={{width:"100%"}} className="btn"  onClick={handleDynamicWorkersReload}><i style={{"marginRight":"5px"}} className={refresh ? "fas fa-redo fa-spin" : "fas fa-redo"} ></i>Refresh</button>
                                        {worker !== "allData" &&  worker !== "0" ?
                                            <button 
                                                style={{width:"100%",marginTop:"10px"}} 
                                                className="btn"
                                                onClick={startStopQueue}>
                                                {/* disabled={queues.length=== 0 ? true: false}> */}
                                                    {processing ? (
                                                            <i
                                                                style={{ fontSize: "15px", color: "#ffffff" }}
                                                                className="fas fa-circle-notch fa-spin"
                                                            ></i>
                                                            ) : queueStatus  ? "Stop" :"Start"}
                                            
                                            </button>
                                        :""}
                                        
                                    </div> : null 
                            }
                            
                        </div>
                        {
                            queLoading?
                                <div style={{ textAlign: "center", marginTop: "15%" }}>
                                    <img src={loader} width="100" alt="loading"></img>
                                </div>
                                : renderQueues()
                        }
                    </div>
                    
                    :
                    <div>
                        <div className="form-inline">
                            <div className="form-group mr-3">
                                <select className="form-control" id="worker" name="worker" value={worker} onChange={handleChange}>
                                    <option value="0">Please select an E-Worker Machine </option>
                                    {workers.map((obj, index) => <option key={index} value={obj.queue_name}>{obj.worker_name}</option>)}
                                </select>
                            </div>
                            {
                                worker !== "0" ? 
                                    <div className="form-group">
                                        <button style={{width:"100%"}} className="btn"  onClick={handleReload}><i style={{"marginRight":"5px"}} className={refresh ? "fas fa-redo fa-spin" : "fas fa-redo"} ></i>Refresh</button>
                                        <button 
                                            style={{width:"100%",marginTop:"10px"}} 
                                            className="btn"
                                            onClick={startStopQueue}>
                                            {/* disabled={queues.length=== 0 ? true: false}> */}
                                                 {processing ? (
                                                        <i
                                                            style={{ fontSize: "15px", color: "#ffffff" }}
                                                            className="fas fa-circle-notch fa-spin"
                                                        ></i>
                                                        ) : queueStatus  ? "Stop" :"Start"}
                                            
                                        </button>
                                    </div> : null 
                            }
                            
                        </div>
                        {
                            queLoading?
                                <div style={{ textAlign: "center", marginTop: "15%" }}>
                                    <img src={loader} width="100" alt="loading"></img>
                                </div>
                                : renderQueues()
                        }
                    </div>
				}
            </div>
            )
        }

    const renderQueues = () => {
        if(queues.length > 0){
            return(
                <div className="content mt-4">
                    <Table hover responsive className="responsive-table">
                        <thead >
                            <tr>
                                <th>Name</th>
                                <th>Bot Name</th>
                                <th>Excecution Type</th>
                                <th>Published By</th>
                                <th>Created Date</th>
                                <th>Status</th>
                                {/* <th></th> */}
                            </tr>
                        </thead>
                        <tbody className="table-body">
                            {queues.sort(compare).map((obj, ind) => {
                                return (
                                    <tr key={ind}>
                                        <td className="schedule-name">
                                          <div>{obj.queue_name}</div>
                                        </td>
                                        <td><div>{obj["TF_BOT.name"]}</div></td>
                                        <td>{obj.execution_type ? obj.execution_type : "-"}</td>
                                        <td style={{wordBreak: "break-all"}}>{obj.email}</td>
                                        <td>{stringToDate(obj.created_at)}</td>
                                        <td style={obj.status === "RUNNING" ? { color: "#02ce9d" } : { color: "orange", fontSize: "15px"}}>
                                            {obj.status === "RUNNING" ? <i className="fas fa-running" data-toggle="tooltip" data-placement="top" title="Running"></i> : 
                                              <i className="fas fa-male" data-toggle="tooltip" data-placement="top" title="Waiting"></i>}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            )
        }else{
            return (
                <div className="empty-container text-center">
                    <img src={EmptyScreen} alt="empty Screen"></img>
                    {worker !== "1" ? <p>You don’t have any Action Flows running</p> : <p>Please Select E-Worker Mechine to check queues</p>}
                </div>
            )
        }
    }

    return(
        <div className="main-content">
            <div className="header-content">
                <label>Queues</label>
            </div>
            { loading ? 
                        <div style={{ textAlign: "center", marginTop: "15%" }}>
                            <img src={loader} width="125" alt="loading"></img>
                        </div> 
                        :  
                        <div>
                            {renderWorkers()}
                        </div>}
            </div>
    )
}

export default Queues;
  
